import React from 'react';
import styles from './Underline.module.scss';

interface UnderlineProps {
  children: React.ReactNode;
  variation?: 'singleLine' | 'multiLine';
  className?: string;
}

const Underline: React.FC<UnderlineProps> = ({
  children,
  variation = 'multiLine',
  className,
}) => {
  return (
    <span
      className={[
        styles.svgUnderline,
        variation === 'singleLine' ? styles.singleLine : styles.multiLine,
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {children}
    </span>
  );
};

export default Underline;
